import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchStore } from "@/store/useSearchStore";
import { useQuery } from "@tanstack/react-query";
const API_KEY = import.meta.env.VITE_TMDB_API_KEY;
const BASE_URL = import.meta.env.VITE_TMDB_BASE_URL;
export async function searchMovie(query) {
    const res = await fetch(`${BASE_URL}/search/movie?api_key=${API_KEY}&query=${encodeURIComponent(query)}`);
    if (!res.ok)
        throw new Error("Failed to fetch movies");
    return res.json();
}
const MovieListWidget = ({ movieId }) => {
    const { setMovieId } = useSearchStore();
    const { data } = useQuery({
        queryKey: ["movie", movieId],
        queryFn: () => searchMovie(movieId),
        enabled: true, // only run when title is not empty
    });
    return (_jsx("div", { className: "rounded-3xl h-full shadow-lg bg-white overflow-auto w-1/2 flex flex-col gap-3 hide-scrollbar", children: (data?.results ?? []).map((movie) => (_jsxs("button", { onClick: () => setMovieId(String(movie.id ?? "")), className: "cursor-pointer p-3 flex gap-2 flex-wrap border-b", children: [_jsx("img", { src: `https://image.tmdb.org/t/p/w185${movie.poster_path}`, alt: movie.title ?? "", className: "w-24 h-36 object-cover rounded-lg flex-shrink-0" }), _jsxs("div", { className: "flex-1", children: [_jsx("h3", { className: "text-lg font-semibold text-gray-900 text-start", children: movie.title }), _jsx("p", { className: "text-base text-gray-600 line-clamp-3 text-start", children: movie.overview })] })] }))) }));
};
export default MovieListWidget;
